import { combineReducers } from "@reduxjs/toolkit";
import mainReducer from "./scenes/Main/main.slice";

const rootReducer = combineReducers({
    main: mainReducer,
});

export default rootReducer;
